<template>
  <div class="introduce container">
    <!-- logo -->
    <div class="intro-logo">
      <img src="../assets/images/jinsehotLogoIntro.svg"/>
    </div>
    <!-- 简介 -->
    <div class="intro-text">
      {{introduce}}
    </div>
  </div>
</template>
<script>
/**
 * 首页简介
 *
 * @requires Home.vue
 * @author liguojie
 */
export default {
  components: {
  },
  name: 'Introduce',
  data () {
    return {
      introduce: 'JinseHot 是全球领先的金融数据服务平台，我们免费向区块链创业者、金融投资机构、研究机构、学术机构、监管机构、媒体等用户提供专业的金融数据服务。通过高效、精准的综合性解决方案助力区块链赋能实体经济。如果你和我们有相同的目标，我们乐意一起携手前行。'
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.introduce{
  margin-top: 75px;
  margin-bottom: 75px;
  .intro-logo{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 35px;
  }
  .intro-text{
    font-size:16px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(33,33,42,1);
    line-height:30px;
  }
}

</style>
